/* CM LX WARENKORB-WAECHTER (16.09.2026)
   Warum diese Datei existiert: assets/theme.js prueft in
   LineItemQuantity._changeLineItemQuantity die Antwort von /cart/change.js nicht.
   Jede Nicht-200-Antwort (400 bei veraltetem line key, 422, 429 Drossel, 5xx) hat
   kein items-Feld, der Zugriff wirft, und die Funktion endet BEVOR sie
   line-item:change und cart:change feuert. Der pill-loader der Zeile bleibt dann
   auf aria-busy stehen und Drawer wie Zaehler bleiben auf dem alten Stand,
   waehrend der Server-Warenkorb sich geaendert hat. Live reproduziert am
   16.09.2026 mit zwei schnellen Klicks auf "Entfernen".

   theme.js selbst wird bewusst nicht angefasst: es ist das unveraenderte
   Impact-Bundle und ein Patch darin waere beim naechsten Theme-Update still weg. */
(function () {
  window.__cmCartGuard = true;

  let kette = Promise.resolve();
  let letzterIntent = null;
  let nachmessTimer = null;
  let letztesNachmessen = 0;
  /* Harte Obergrenze fuer Wiederholungen. Ohne sie wuerde eine anhaltende
     Storefront-Drossel den Waechter alle drei Sekunden erneut /cart.js abrufen
     lassen und die Drossel damit selbst am Leben halten. */
  let leseWiederholungen = 0;

  function wurzel() {
    return window.Shopify.routes.root;
  }

  function laderEntfernen() {
    document.querySelectorAll("pill-loader[aria-busy]").forEach((loader) => {
      loader.removeAttribute("aria-busy");
    });
  }

  function zaehlerAktualisieren(itemCount) {
    document.querySelectorAll("cart-count").forEach((zaehler) => {
      zaehler.textContent = itemCount;
    });
  }

  function drawerWeichtAb(cart) {
    /* Ohne Drawer im Dokument gibt es nichts abzugleichen. Sonst gilt jede Seite
       ohne Drawer dauerhaft als abweichend und loest Heilung um Heilung aus. */
    if (!document.querySelector("cart-drawer")) {
      return false;
    }

    const eingaben = Array.from(document.querySelectorAll("cart-drawer [data-line-key]"));
    const mengenNachKey = new Map();

    eingaben.forEach((eingabe) => {
      const key = eingabe.getAttribute("data-line-key");
      const menge = Number.parseInt(eingabe.value, 10);

      if (!mengenNachKey.has(key)) {
        mengenNachKey.set(key, []);
      }

      mengenNachKey.get(key).push(menge);
    });

    if (cart.item_count > 0 && mengenNachKey.size === 0) {
      return true;
    }

    if (mengenNachKey.size !== cart.items.length) {
      return true;
    }

    return cart.items.some((item) => {
      const mengen = mengenNachKey.get(item.key);
      return !mengen || mengen.some((menge) => menge !== item.quantity);
    });
  }

  function anzeigeWeichtAb(cart) {
    const zaehlerWeichtAb = Array.from(document.querySelectorAll("cart-count")).some((zaehler) => {
      return Number.parseInt(zaehler.textContent, 10) !== cart.item_count;
    });

    return zaehlerWeichtAb || drawerWeichtAb(cart);
  }

  function nachmessungPlanen(verzoegerung, nachHeilung) {
    window.clearTimeout(nachmessTimer);
    nachmessTimer = window.setTimeout(() => {
      nachmessen(nachHeilung);
    }, verzoegerung);
  }

  function heilen(cart) {
    laderEntfernen();
    zaehlerAktualisieren(cart.item_count);
    document.dispatchEvent(new CustomEvent("cart:refresh"));
    nachmessungPlanen(1500, true);
  }

  async function korbVomServerLesen(erneutVersuchen) {
    let response;

    try {
      response = await fetch(`${wurzel()}cart.js`);
    } catch (error) {
      console.warn("CM LX Warenkorb konnte nicht nachgemessen werden", error);
      return null;
    }

    const contentType = response.headers.get("content-type") || "";
    if (!response.ok || !contentType.includes("application/json")) {
      console.warn("CM LX Warenkorb lieferte keine JSON Antwort", response.status);

      if (erneutVersuchen && leseWiederholungen < 1) {
        leseWiederholungen += 1;
        nachmessungPlanen(3000, false);
      }

      return null;
    }

    try {
      const cart = await response.json();
      leseWiederholungen = 0;
      return cart;
    } catch (error) {
      console.warn("CM LX Warenkorb JSON konnte nicht gelesen werden", error);
      return null;
    }
  }

  async function nachmessen(nachHeilung) {
    const jetzt = Date.now();
    if (!nachHeilung && jetzt - letztesNachmessen < 2000) {
      nachmessungPlanen(2000 - (jetzt - letztesNachmessen), false);
      return;
    }

    letztesNachmessen = jetzt;
    const cart = await korbVomServerLesen(!nachHeilung);

    if (!cart || !Array.isArray(cart.items)) {
      return;
    }

    if (!anzeigeWeichtAb(cart)) {
      return;
    }

    if (nachHeilung) {
      console.warn("CM LX Warenkorb weicht nach der Heilung weiter ab");
      return;
    }

    heilen(cart);
  }

  function nachmessungAnstossen() {
    /* Neue Nutzerhandlung, also faengt das Wiederholungsbudget von vorn an. */
    leseWiederholungen = 0;
    nachmessungPlanen(2200, false);
  }

  function laderDerZeileEntfernen(lineItem) {
    lineItem?.querySelector("pill-loader")?.removeAttribute("aria-busy");
  }

  function prototypPatchen() {
    const LineItemQuantity = window.customElements.get("line-item-quantity");
    if (!LineItemQuantity || LineItemQuantity.prototype.cmLxCartGuardPatched) {
      return;
    }

    LineItemQuantity.prototype.cmLxCartGuardPatched = true;
    LineItemQuantity.prototype._changeLineItemQuantity = function (lineKey, targetQuantity) {
      if (!lineKey || !Number.isFinite(targetQuantity) || targetQuantity < 0) {
        return;
      }

      if (window.themeVariables.settings.pageType === "cart") {
        window.location.href = `${wurzel()}cart/change?id=${lineKey}&quantity=${targetQuantity}`;
        return;
      }

      const intent = { lineKey, targetQuantity };
      if (letzterIntent && letzterIntent.lineKey === lineKey && letzterIntent.targetQuantity === targetQuantity) {
        return;
      }

      letzterIntent = intent;
      const ausfuehren = async () => {
        const lineItem = this.closest("line-item");
        let timeout;

        lineItem?.dispatchEvent(new CustomEvent("line-item:will-change", { bubbles: true, detail: { targetQuantity } }));

        try {
          const sectionsToBundle = [];
          document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: sectionsToBundle } }));

          const controller = new AbortController();
          timeout = window.setTimeout(() => controller.abort(), 12000);
          const response = await fetch(`${wurzel()}cart/change.js`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              id: lineKey,
              quantity: targetQuantity,
              sections: sectionsToBundle
            }),
            signal: controller.signal
          });
          const cartContent = await response.json();

          if (!response.ok || !Array.isArray(cartContent.items)) {
            console.warn("CM LX Warenkorbaenderung fehlgeschlagen", response.status);
            const cart = await korbVomServerLesen(true);

            if (cart) {
              heilen(cart);
            }
            return;
          }

          const hatDrawerSection = sectionsToBundle.some((section) => {
            return typeof cartContent.sections?.[section] === "string";
          });

          if (!hatDrawerSection) {
            console.warn("CM LX Warenkorbaenderung ohne Drawer Section");
            heilen(cartContent);
            return;
          }

          const lineItemNachAenderung = cartContent.items.filter((item) => item.key === lineKey);
          lineItem?.dispatchEvent(new CustomEvent("line-item:change", {
            bubbles: true,
            detail: {
              quantity: lineItemNachAenderung.length === 0 ? 0 : lineItemNachAenderung[0].quantity,
              cart: cartContent
            }
          }));
          document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
            bubbles: true,
            detail: {
              baseEvent: "line-item:change",
              cart: cartContent
            }
          }));
        } catch (error) {
          console.warn("CM LX Warenkorbaenderung konnte nicht abgeschlossen werden", error);
          const cart = await korbVomServerLesen(true);

          if (cart) {
            heilen(cart);
          }
        } finally {
          window.clearTimeout(timeout);
          laderDerZeileEntfernen(lineItem);
          nachmessungAnstossen();

          if (letzterIntent === intent) {
            letzterIntent = null;
          }
        }
      };

      const naechsterSchritt = kette.then(ausfuehren, ausfuehren);
      kette = naechsterSchritt.catch(() => {});
      return naechsterSchritt;
    };
  }

  document.addEventListener("variant:add", nachmessungAnstossen);
  document.addEventListener("cart:change", nachmessungAnstossen);
  document.addEventListener("submit", (event) => {
    if (event.target.matches('form[is="product-form"]')) {
      nachmessungAnstossen();
    }
  }, true);

  window.customElements.whenDefined("line-item-quantity").then(prototypPatchen);
})();
